<template>
    <footer>
        <div class="top-row">
            <div v-if="footer.subscription.isEnabled" class="top-row--subscription">
                <div class="top-row--subscription--image--wrapper">
                    <img v-if="footer.subscription.image?.url" :src="footer.subscription.image.url"
                        alt="Subscription Image" class="top-row--subscription--image"></img>
                </div>
                <h5>{{ footer.subscription.title }}</h5>
                <p>{{ footer.subscription.text }}</p>
                <form @submit.prevent="onSubmit">
                    <div class="field-group">
                        <Input
                            :placeholder="footer.subscription.translations['home.Subscription.EmailAddress']"></Input>
                        <Button type="submit">
                            <SendHorizonalIcon></SendHorizonalIcon>
                        </Button>
                    </div>
                </form>
            </div>
            <div class="links">
                <div v-for="item in footer.linksSection">
                    <h5>{{ item.title }}</h5>
                    <ul>
                        <li v-for="itemLink in item.links" class="li-item">
                            <a :href="itemLink.url" :target="itemLink.target">{{ itemLink.text }}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="bottom-row">
            <div class="bottom-row--decoration">
                <img :src="footer.bottomRow.leftImage.url"></img>
                <img :src="footer.bottomRow.rightImage.url"></img>
            </div>
            <div class="bottom-row--section">
                <div>{{ footer.bottomRow.title }}</div>
                <div class="bottom-row--links">
                    <Button v-for="value in footer.bottomRow.links" variant="link" as-child class="link-button"
                        size="sm"><a :href="value.url" :target="value.target">{{ value.text }}</a></Button>
                </div>
            </div>
        </div>
    </footer>
</template>
<script lang="ts" setup>
import Button from '../ui/button/Button.vue';
import { IFooterBarProps } from './FooterBar.model';
import { Input } from '../ui/input';
import { toTypedSchema } from '@vee-validate/zod';
import * as z from 'zod';
import { useForm } from 'vee-validate';
import { SendHorizonalIcon } from 'lucide-vue-next';
const { footer } = defineProps<IFooterBarProps>()

const formSchema = toTypedSchema(z.object({
    email: z.email(),
}))

const form = useForm({
    validationSchema: formSchema,
})

const onSubmit = form.handleSubmit((values) => {
    console.log(values)
})

</script>
<style lang="scss" scoped>
h5 {
    color: var(--primary);
    font-size: 1rem;
    font-weight: 800;
    text-transform: uppercase;
}

:global(*:has(+ footer)) {
    flex: 1
}

footer {
    margin-top: 15px;
    background-color: var(--primary-foreground);
    color: var(--background);


    &::before {
        content: "";
        display: block;
        margin-top: 15px;

        &+* {
            flex: 1;
        }
    }

}

.top-row {
    display: flex;
    flex-direction: column;
    padding: 8px 12px;
}

.top-row--subscription--image {
    max-height: 50px;
    object-fit: cover;
}

.field-group {
    display: flex;
    gap: 5px;
    flex-direction: column;
}

@media (min-width: 768px) {
    .field-group {
        flex-direction: row;
    }
}


.bottom-row {
    display: flex;
    flex-direction: column;
}

.bottom-row--decoration {
    display: flex;
    justify-content: space-evenly;
}

.bottom-row--section {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    gap: 8px;
    background-color: var(--primary);
    padding: 8px 12px;
}

.bottom-row--links {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .link-button {
        color: var(--background);
    }
}

.links {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 30px;
}

@media (min-width: 768px) {
    .top-row--subscription--image--wrapper {
        min-height: 50px;
    }

    .links {
        flex-direction: row;
        justify-content: space-evenly;
        flex: 1;
        margin-top: 50px;
        gap: unset;

        .li-item {
            padding-left: 10px;
        }
    }

    .top-row {
        flex-direction: row;
        padding: 50px 120px;
    }

    .bottom-row--section {
        flex-direction: row;
    }

    .bottom-row--links {
        gap: 0px;
        flex-direction: row;
    }
}
</style>